import RowsCache from "../jslibs/RowsCache";
import { ITreeNode } from "../libs/tree/TreeNode";
import { ITreeNodeFinder } from "../libs/tree/TreeNodeSession";
import { ComputePath, Dir } from "../shared/FMFile";
import FManApi from "./FManApi";

export class GDir extends Dir implements ITreeNode<GDir> {
    private _children:GDir[] = []
    private _parent:GDir|null = null
    private _path:string = ""
    private _expanded:boolean = false

    get children(){return this._children}
    get parent(){return this._parent}
    get path(){return this._path}
    get expanded(){return this._expanded}
    get name(){return super.name || "/"}
    
    set expanded(expanded:boolean){ this.setExpanded(expanded) }
    setExpanded(expanded:boolean) { 
        this._expanded = expanded; 
        this.emit("toggle", this)
        return this 
    }

    addToggleHandler(handler:any) {
        return this.on("toggle", handler)
    }

    removeToggleHandler(handler: any) {
        return this.removeListener("toggle", handler)
    }    

    setPath(path:string) {
        this._path = path
        return path
    }
    addChild(child:GDir){
        this.children.push(child.setParent(this))
        return this
    }
    setParent(parent:GDir){
        this._parent = parent
        return this
    }
    getChildByName(name:string){
        return this._children.find(child => child.name==name)
    }
    static deserialize(dir:string){
        const [_id,parentId,name] = dir.split(":")
        return new GDir({_id,parentId,name})
    }

    computePath() { ComputePath(this) }
}

export default class Dirs extends RowsCache<GDir> implements ITreeNodeFinder<GDir> {
    static _i:Dirs
    static get i(){
        if (!this._i) this._i = new Dirs("dirs", 0)
        return this._i
    }
    private _root:GDir = new GDir({_id:Dir.ROOT_ID,parentId:null,name:""})

    get root(){
        return this.get().then(() => this._root)
    }
    async fetch(): Promise<GDir[]> {
        return FManApi.i.getDirs()
    }
    key(row: GDir): string {
        return row._id
    }
    protected onCache(cache:GDir[]){
        super.onCache(cache)
        for(const dir of cache){
            const parentId = dir.parentId
            if (parentId){
                const parent = this.fromCache(parentId)
                if (!parent) console.warn(`${dir._id}:${dir.name}'s parent ${dir.parentId} doesn't exist`)
                else parent.addChild(dir)
            }else{
                this._root = dir
            }
        }
        for(const dir of cache){
            dir.computePath()
        }
    }
    async findPath(rootId:string, path:string){
        try {
            let root = await this.one(rootId)
            const paths = path.split("/").filter(path => !!path)
            for(const dir of paths){
                const child = root.getChildByName(dir)
                if (!child) return null
                root = child
            }
            return root
        }
        catch(e){
            return null
        }
    }
    async createPath(rootId:string, path:string){
        const dirs = await FManApi.i.createDirs(rootId, path)
        const added:GDir[] = []
        for(const dir of dirs){
            if (!this.fromCache(dir._id)) added.push(this.add(dir))
        }
        for(const dir of added) {
            if (!dir.parentId) {
                console.warn(`${dir._id}:${dir.name}'s parent isn't set!`)
                this._root.addChild(dir)
            }else{
                const parent = this.fromCache(dir.parentId)
                if (!parent) console.warn(`${dir._id}:${dir.name}'s parent ${dir.parentId} doesn't exist`)
                else parent.addChild(dir)
            }
        }
    }
    findNode(id:string){
        return this.fromCache(id)
    }
}